import { CategoryRepository, CreateCategoryInput } from '../../domain/repositories/category.repository';
import { CategoryEntity } from '../../domain/entities/category.entity';

export class CreateCategoryUseCase {
  constructor(private readonly categoryRepository: CategoryRepository) {}

  async execute(input: CreateCategoryInput): Promise<CategoryEntity> {
    return this.categoryRepository.createCategory(input);
  }
}
